import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddSellerBanner() {
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [bannerPackages, setBannerPackages] = useState([]);
  const [selectedBannerPackage, setSelectedBannerPackage] = useState(null);
  const [bannerPackagesLoading, setBannerPackagesLoading] = useState(true);
  const [banner, setBanner] = useState({
    title: "",
    start_date: "",
    end_date: "",
    banner_image: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // fetch admin banner packages

  const fetchAdminBannerPackages = async () => {
    try {
      const response = await USER_URL.get(
        `/products/seller/packages/?promotion_type=Banner`,
      );
      console.log("Banner Packages Response:", response.data);
      setBannerPackages(response.data.Data);
      setBannerPackagesLoading(false);
    } catch (error) {
      console.error("Error fetching banner packages:", error.message || error);
      toast.error("Failed to fetch banner packages!");
    }
  };
  // Fetch products on component load
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/products/seller/`, {});
        if (response.data?.Data) {
          setProducts(response.data.Data);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
        toast.error("Failed to fetch products!");
      }
    };
    fetchAdminBannerPackages();
    fetchProducts();
  }, [token]);

  // Handle changes to the banner form
  const handleBannerChange = (e) => {
    const { name, value, files } = e.target;
    setBanner((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  // Handle selecting/deselecting a product
  const handleProductSelect = (productId) => {
    setSelectedProducts((prev) => {
      const existingProduct = prev.find((p) => p.product === productId);

      if (existingProduct) {
        // If already selected, remove it from the list
        return prev.filter((p) => p.product !== productId);
      } else {
        // If not selected, add it and retain its uploaded image if available
        const productWithImage = products.find((p) => p.id === productId);
        return [
          ...prev,
          {
            product: productId,
            product_banner_image:
              productWithImage?.product_banner_image || null,
          },
        ];
      }
    });
  };

  // Handle product-specific banner image changes
  const handleProductImageChange = (e, productId) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);

      setSelectedProducts((prev) => {
        const productExists = prev.some((p) => p.product === productId);

        if (productExists) {
          // Update existing product's image
          return prev.map((p) =>
            p.product === productId ? { ...p, product_banner_image: file } : p,
          );
        } else {
          // Automatically add product when an image is uploaded
          return [
            ...prev,
            {
              product: productId,
              product_banner_image: file,
            },
          ];
        }
      });

      // Update the products list for live image preview
      setProducts((prev) =>
        prev.map((p) =>
          p.id === productId
            ? { ...p, product_banner_image: file, imageUrl }
            : p,
        ),
      );
    }
  };

  // Submit banner data
  const handleSubmit = async () => {
    // Validate required fields
    if (!selectedBannerPackage) {
      toast.warn("Please select a banner package.");
      return;
    }
    if (!banner.title) {
      toast.warn("Please enter the banner title.");
      return;
    }
    if (!banner.banner_image) {
      toast.warn("Please upload a banner image.");
      return;
    }
    if (!banner.start_date) {
      toast.warn("Please select a start date.");
      return;
    }
    // if (!banner.end_date) {
    //   toast.warn("Please select an end date.");
    //   return;
    // }
    if (selectedProducts.length === 0) {
      toast.warn(
        "Please select at least one product to include in the banner.",
      );
      return;
    }
    

    // Validate product banner images
    const invalidProducts = selectedProducts.filter(
      (p) => !p.product_banner_image,
    );
    if (invalidProducts.length > 0) {
      // Generate a detailed alert with product names or IDs
      const missingImages = invalidProducts
        .map((p) => {
          const product = products.find((prod) => prod.id === p.product);
          return product
            ? `${product.name} (ID: ${product.id})`
            : `Product ID: ${p.product}`;
        })
        .join("\n");

      toast.warn("The following products are missing their images");
      return;
    }
    setIsSubmitting(true); // Set isSubmitting to true when the form submission starts

    // Prepare form data
    const formData = new FormData();
    formData.append("title", banner.title);
    formData.append("banner", banner.banner_image);
    formData.append("start_date", banner.start_date);
    // formData.append("end_date", banner.end_date);
    formData.append("package", selectedBannerPackage.id);
    // Append each product dynamically
    selectedProducts.forEach((p, index) => {
      formData.append(`banner_products[${index}]product`, p.product);
      formData.append(
        `banner_products[${index}]product_banner_image`,
        p.product_banner_image,
      );
    });

    // Submit the form
    try {
      const response = await USER_URL.post(
        `/products/seller/banners/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      toast.success("Banner created successfully!");
      console.log("Response Data:", response.data);
      // Reset all state values to their initial states
      setBanner({
        title: "",
        // start_date: "",
        // end_date: "",
        banner_image: null,
        
      });
      setSelectedBannerPackage(null);
      setSelectedProducts([]);
      navigate("/seller/offer/banner")
    } catch (error) {
      console.error(
        "Error creating banner:",
        error.response?.data || error.message || error,
      );

      toast.error("Failed to create banner. Please try again.");
    } finally {
      setIsSubmitting(false); // Reset isSubmitting to false after submission completes
    }
  };
  return (
    <div>
      <div className="mb-5 mt-5">
        <h2 className="mb-4 text-center text-3xl font-medium text-brand-primary">
          Pick Your Banner Package
        </h2>
        {bannerPackagesLoading ? (
          <div>Loading...</div>
        ) : (
          <div className="flex w-full flex-wrap items-center justify-around gap-2">
            {bannerPackages.map((item) => (
              <div
                key={item.id}
                className={`flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 p-4 text-center shadow-md transition duration-300 ease-in-out hover:shadow-lg md:w-[300px] ${
                  selectedBannerPackage?.id === item.id
                    ? "border-green-600 bg-green-50"
                    : "border-gray-300 bg-white"
                }`}
                onClick={() => setSelectedBannerPackage(item)}
              >
                <div>
                  <h3 className="text-lg font-semibold">{item.name}</h3>
                  <p className="text-sm text-gray-600">Period: {item.period}</p>
                  <p className="text-sm text-gray-600">
                    Duration: {item.duration_days} day(s)
                  </p>
                  <p className="text-sm text-gray-600">Price: ₹{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-10 rounded-lg border-2 bg-gray-50 p-6 shadow-lg">
        <div className="flex justify-end text-center">
          <button
            onClick={() => navigate(-1)} // Use navigate(-1) to go back
            className="flex items-center text-sm font-medium text-green-600 hover:text-green-700 focus:outline-none"
          >
            <span>&lt; Back to Banner List</span>
          </button>
        </div>
        <h2 className="mb-6 text-center text-3xl font-medium text-green-700">
          Create Banner
        </h2>
        {/* Banner Image Section */}
        <div className="mb-6 flex w-full flex-col gap-6 sm:mb-8 sm:flex-row sm:gap-8">
          <div className="w-full sm:w-1/2">
            <label className="mb-2 block font-medium text-gray-700">
              Banner Image
            </label>
            <div className="rounded-md border">
              {banner.banner_image ? (
                <div className="relative">
                  <img
                    src={URL.createObjectURL(banner.banner_image)}
                    alt="Banner Preview"
                    className="mb-4 h-44 w-full rounded-md object-cover"
                  />
                  {/* <button
                  type="button"
                  className="absolute top-2 right-2 bg-red-500 text-white rounded-full px-2 py-1 text-xs"
                  onClick={() => setBanner({ ...banner, banner_image: null })}
                >
                  Remove
                </button> */}
                </div>
              ) : (
                <div className="mb-4 flex h-40 w-full items-center justify-center rounded-md bg-gray-100 text-gray-500">
                  No Image Selected
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];

                  setBanner({ ...banner, banner_image: file });
                }}
                className="mb-3 ml-3 text-sm text-gray-600 file:mr-4 file:rounded-full file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>
          </div>

          {/* Banner Details Section */}
          <div className="w-full sm:w-1/2">
            <div>
              <label className="mb-2 block font-medium text-gray-700">
                Banner Name
              </label>
              <input
                type="text"
                name="title"
                value={banner.title}
                onChange={handleBannerChange}
                className={`mb-3 w-full rounded border p-2 ${!banner.title}`}
                placeholder="Enter banner name"
              />
            </div>
             <div>
              <label className="mb-2 block font-medium text-gray-700">
                Start Date
              </label>
              <input
                type="date"
                name="start_date"
                value={banner.start_date}
                onChange={handleBannerChange}
                className="mb-3 w-full rounded border p-2"
              />
            </div>
           {/* <div>
              <label className="mb-2 block font-medium text-gray-700">
                End Date
              </label>
              <input
                type="date"
                name="end_date"
                value={banner.end_date}
                onChange={handleBannerChange}
                className="w-full rounded border p-2"
              />
            </div> */}
            <div className="flex gap-3">
              <label className="mb-2 font-medium text-gray-700">Period :</label>
              <p>{selectedBannerPackage?.period}</p>
            </div>
            <div className="flex gap-3">
              <label className="mb-2 font-medium text-gray-700">
                Duration :
              </label>
              {selectedBannerPackage?(<p>{selectedBannerPackage?.duration_days} days</p>): <p>0 days</p>}
            </div>
            {/* Submit Button */}
            <div>
              <button
                onClick={handleSubmit}
                // disabled={
                //   isSubmitting || // Disable the button while submitting
                //   !banner.title ||
                //   !banner.banner_image ||
                //   !banner.start_date ||
                //   !banner.end_date ||
                //   selectedProducts.length === 0
                // }
                className={`mt-6 w-full rounded bg-green-600 px-6 py-3 text-white hover:bg-green-700 ${
                  isSubmitting ||
                  !banner.title ||
                  !banner.banner_image ||
                  !banner.start_date ||
                  !banner.end_date ||
                  selectedProducts.some((p) => !p.product_banner_image) ||
                  selectedProducts.length === 0
                }`}
              >
                {isSubmitting ? "Submitting..." : "Submit Banner"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Products Table */}
      <div className="mt-6">
        <h2 className="mb-4 text-xl font-bold">Products</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr>
                <th className="px-2 py-2 text-sm font-bold text-green-500">
                  Item No
                </th>
                <th className="px-2 py-2 text-sm font-bold text-green-500">
                  Porduct Code
                </th>
                <th className="px-2 py-2 text-sm font-bold text-green-500">
                  Product Name
                </th>
                <th className="px-2 py-2 text-sm font-bold text-green-500">
                  Stock
                </th>
                <th className="px-2 py-2 text-sm font-bold text-green-500">
                  Price
                </th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={product.id}>
                  {/* Serial Number */}
                  <td className="px-2 py-2">
                    <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {index + 1}
                    </div>
                  </td>

                  <td className="px-2 py-2">
                    <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {product.product_code}
                    </div>
                  </td>

                  {/* Name */}
                  <td className="px-2 py-2">
                    <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {product.name}
                    </div>
                  </td>
                  {/* Stock */}
                  <td className="px-2 py-2">
                    <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {product.stock}
                    </div>
                  </td>

                  {/* Price */}
                  <td className="px-2 py-2">
                    <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {product.price}
                    </div>
                  </td>

                  {/* Upload Image Column */}
                  <td className="px-2 py-2">
                    <div className="flex flex-1 items-center">
                      <input
                        type="file"
                        accept="image/*"
                        id={`upload-input-${product.id}`}
                        onChange={(e) =>
                          handleProductImageChange(e, product.id)
                        }
                        className="hidden" // Hide the input
                      />
                      <label
                        htmlFor={`upload-input-${product.id}`} // Associate the label with the input
                        className="flex flex-1 items-center justify-center rounded-lg border border-blue-600 px-2 py-2 text-center text-xs font-medium text-blue-600 shadow-md transition hover:border-blue-700 hover:bg-blue-700 hover:text-white sm:text-sm"
                      >
                        Upload
                      </label>
                    </div>
                  </td>

                  {/* Image Column */}
                  <td className="py-2">
                    <div className="flex flex-1 items-center justify-center rounded-lg">
                      {selectedProducts.find((p) => p.product === product.id)
                        ?.product_banner_image ||
                      product.product_banner_image ||
                      product.image ? (
                        <img
                          src={
                            selectedProducts.find(
                              (p) => p.product === product.id,
                            )?.product_banner_image
                              ? URL.createObjectURL(
                                  selectedProducts.find(
                                    (p) => p.product === product.id,
                                  ).product_banner_image,
                                )
                              : product.product_banner_image
                                ? URL.createObjectURL(
                                    product.product_banner_image,
                                  )
                                : product.image
                          }
                          alt={product.name}
                          className="h-20 w-28 rounded object-cover shadow-md"
                        />
                      ) : (
                        <div className="flex h-20 w-28 items-center justify-center rounded border border-gray-300 bg-gray-100">
                          <span className="text-xs text-gray-500">
                            No Image
                          </span>
                        </div>
                      )}
                    </div>
                  </td>

                  {/* Action Buttons */}
                  <td className="px-2 py-2">
                    <div className="flex flex-1 items-center justify-center">
                      <button
                        onClick={() => handleProductSelect(product.id)}
                        className={`flex items-center justify-center rounded-lg border py-2 text-center text-xs font-medium shadow-md transition hover:text-white sm:text-sm md:w-[130px] ${
                          selectedProducts.some((p) => p.product === product.id)
                            ? "border border-red-600 text-red-600 hover:border-red-700 hover:bg-red-700"
                            : "border-green-600 text-green-600 hover:border-green-700 hover:bg-green-700"
                        }`}
                      >
                        {selectedProducts.some((p) => p.product === product.id)
                          ? "Remove"
                          : "Add to Banner"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AddSellerBanner;
